import {SensitiveValue} from "client/resources/sensitiveValue";

export function createEmptySensitiveValue(): SensitiveValue {
    return {HasValue: false};
}